module.exports = __webpack_public_path__ + "static/media/shirt.627de052.png";